import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = ["data-qa"]
const _hoisted_3 = ["data-qa"]
const _hoisted_4 = ["data-qa"]

import VitaButton from './VitaButton.vue'
import VitaIcon from './VitaIcon.vue'

interface Props {
  /** Описание заглушки и её статуса/типа для data-qa, напр. "beru-free-empty" */
  qaName: string
  icon?: string
  iconWidth?: string
  iconHeight?: string
  message: string
  description?: string
  onRefreshClick?: () => void
  refreshBtnDisabled?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaEmptyPlaceholder',
  props: {
    qaName: {},
    icon: {},
    iconWidth: {},
    iconHeight: {},
    message: {},
    description: {},
    onRefreshClick: { type: Function },
    refreshBtnDisabled: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["placeholder", __props.icon]),
    "data-qa": `placeholder-${__props.qaName}-block`
  }, [
    (__props.icon)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["placeholder-icon", __props.icon]),
          style: _normalizeStyle({
        width: `${__props.iconWidth}px`,
        minWidth: `${__props.iconWidth}px`,
        height: `${__props.iconHeight}px`,
        minHeight: `${__props.iconHeight}px`
      }),
          "data-qa": `placeholder-${__props.qaName}-icon`
        }, null, 14, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: "placeholder-message",
      "data-qa": `placeholder-${__props.qaName}-message`
    }, _toDisplayString(__props.message), 9, _hoisted_3),
    _createElementVNode("span", {
      class: "placeholder-description",
      "data-qa": `placeholder-${__props.qaName}-description`
    }, _toDisplayString(__props.description), 9, _hoisted_4),
    (__props.onRefreshClick)
      ? (_openBlock(), _createBlock(VitaButton, {
          key: 1,
          type: "clear",
          "button-type": "button",
          class: "placeholder-btn",
          disabled: __props.refreshBtnDisabled,
          onClick: __props.onRefreshClick,
          "data-qa": `placeholder-${__props.qaName}-button-refresh`
        }, {
          default: _withCtx(() => [
            _createVNode(VitaIcon, { name: "update" }),
            _cache[0] || (_cache[0] = _createElementVNode("span", null, "Обновить", -1))
          ]),
          _: 1
        }, 8, ["disabled", "onClick", "data-qa"]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})